import notifications from '../api/notifications'

export default {
  state: {
    notifications: [],

  },
  namespaced: true,
  mutations: {
    async saveNotifications(state, notifications) {
      state.notifications = notifications;
    },
    async updateNotification(state, notification) {
      state.notifications.forEach(item=>{
        if(item.noteId === notification.noteId){
          item.status = notification.status
        }
      })
    },
  },
  actions: {
    async getNotifications({dispatch, commit}, data) {
      commit('saveNotifications', await notifications.getNotifications(data));
    },
    async updateNotification({dispatch, commit}, data) {
      try {
         await notifications.updateNotification(data);
         commit('updateNotification', data);
      } catch (e) {
        console.error(e)
      }
    }
  },
  getters: {
    getNotifications: state => state.notifications
  },
}
